import React, { useEffect, useState } from "react";
import ShopHeader from "../../header/header";
import Footer from "../footer";
import {
  BigTextInput,
  PrimaryButton,
  TextInput,
} from "../../../../admin/components/inputs";
import axiosInstance from "../../../../AxiosInstance";
import PageTitle from "../../page_title/page_title";

export default function Contact() {
  const [form, setForm] = useState({});
  const [showSuccess, setShowSuccess] = useState(false);

  useEffect(() => {
    document.title = "Contact | Bring Me";
  }, []);

  const submit = () => {
    axiosInstance
      .post("contact_message/", {
        message: form["message"],
      })
      .then((response) => {
        setShowSuccess(true);
      });
  };

  return (
    <div>
      <ShopHeader />

      <div style={{ paddingTop: "80px" }} className={"pb-5"}>
        <PageTitle name="Contactez-nous" />

        <div
          className="container mx-auto pb-5 mt-5"
          style={{ maxWidth: "800px" }}
        >
          <div className="card shadow-sm p-4 mb-4">
            <h4 className="mb-4 text-primary">Envoyez-nous un message</h4>

            {showSuccess ? (
              <div className="alert alert-success" role="alert">
                <h5 className="alert-heading">Message envoyé avec succès!</h5>
                <p>
                  Merci de nous avoir contacté. Nous vous répondrons dans les
                  plus brefs délais.
                </p>
              </div>
            ) : (
              <div>
                <div className="mb-4">
                  <TextInput
                    name={"nom"}
                    placeholder="Votre nom"
                    form={form}
                    setForm={setForm}
                  />
                </div>
                <div className="mb-4">
                  <TextInput
                    name={"email"}
                    placeholder="Votre email"
                    form={form}
                    setForm={setForm}
                  />
                </div>
                <div className="mb-4">
                  <BigTextInput
                    name={"message"}
                    placeholder="Votre message"
                    form={form}
                    setForm={setForm}
                  />
                </div>
                <div className="d-grid">
                  <PrimaryButton name={"Envoyer"} onClick={() => submit()} />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
